import { Headers } from '@egw/components'
import { type FeatureFlags } from '@egw/constants'
import { ConsumerEngagementFeed } from '@egw/consumer-engagement'
import { useFlags } from '@egw/feature-flags'
import { ResponsiveAdviceOverviewPage } from '@egw/features-account'
import { usePlaidMultiLinkContext } from '@egw/features-external-accounts/src/components'
import { PlaidMultiLinkWrapper } from '@egw/features-external-accounts/src/components/plad-multi-link'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const OverviewPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.overview.title')} />
      <PlaidWrappedOverviewPage />
    </Layout>
  )
}

const PlaidWrappedOverviewPage: FC = () => {
  return (
    <PlaidMultiLinkWrapper>
      <PlaidWrappedOverviewContent />
    </PlaidMultiLinkWrapper>
  )
}

const PlaidWrappedOverviewContent: FC = () => {
  const { flags } = useFlags<FeatureFlags>()
  const { openModal } = usePlaidMultiLinkContext()

  return (
    <ResponsiveAdviceOverviewPage onLinkAccounts={openModal}>
      {flags.rolloutConsumerEngagementInsights ? (
        <ConsumerEngagementFeed enableCustomTargets id="overview-feed" />
      ) : null}
    </ResponsiveAdviceOverviewPage>
  )
}
